import { store } from 'redux/store';
import { Range } from 'types';
import { isValidRangeForPartner } from 'modules/partners/api/isValidRangeForPartner';

type CheckIsValidRangeProps = {
  range: Range;
  availableRanges: Range[];
  addedRanges: Range[];
};

const checkIsInvalidData = (range: Range, availableRanges: Range[]) =>
  !availableRanges ||
  availableRanges.length === 0 ||
  !range?.partner ||
  !range?.shareClass;

const checkIsRangeAvailable = (range: Range, availableRanges: Range[]): Range =>
  availableRanges.find(
    (availableRange: Range) =>
      availableRange.from <= range.from && availableRange.to >= range.to
  ) || { from: -1, to: -1 };

const checkIsRangeInAddedRanges = (
  range: Range,
  addedRanges: Range[]
): boolean =>
  addedRanges.some(
    (addedRange: Range) =>
      addedRange.from <= range.from &&
      addedRange.to >= range.to &&
      range.partner === addedRange.partner &&
      range.shareClass === addedRange.shareClass
  );

const fetchRangeResult = async (range: Range) =>
  // eslint-disable-next-line no-return-await
  await store.dispatch(
    isValidRangeForPartner({
      partnerId: range.partner!,
      holdingClassId: range.shareClass!,
      shareFrom: range.from,
      shareTo: range.to,
    })
  );

export const checkIsValidRange = async ({
  range,
  availableRanges,
  addedRanges,
}: CheckIsValidRangeProps): Promise<Range> => {
  const isInvalidData = checkIsInvalidData(range, availableRanges);
  const isInAddedRanges = checkIsRangeInAddedRanges(range, addedRanges);

  if (isInvalidData || isInAddedRanges) {
    return {
      from: -1,
      to: -1,
      partner: range.partner || '',
      shareClass: range.shareClass || '',
    };
  }

  const availableRange = checkIsRangeAvailable(range, availableRanges);
  if (availableRange.from !== -1) {
    return {
      from: availableRange.from,
      to: availableRange.to,
      partner: range.partner || '',
      shareClass: range.shareClass || '',
    };
  }

  const resultRange = await fetchRangeResult(range);

  return resultRange;
};
